import { Icon, Info, MenuButton, Tooltip } from '@silverfort/sf-components';

const InsightBanner = ({ icon, title = '', dataElements = [], menuContent, className, info }) => {
    return (
        <div
            className={`w-full hover:border-sf-gray-300 h-24 rounded-lg px-4 justify-center flex flex-col gap-4 font-sf text-sf-gray-800 border border-sf-gray-100 ${className}`}>
            <div className="flex items-center h-6 justify-between">
                <div className="flex gap-1 items-center truncate">
                    {icon && <Icon icon={icon} className="h-5 w-5 text-sf-gray-400" />}
                    <div className="text-12 font-medium">{title}</div>
                    {info && (
                        <div>
                            <Tooltip width="w-full" title={info}>
                                <Info />
                            </Tooltip>
                        </div>
                    )}
                </div>
                {menuContent && (
                    <div>
                        <MenuButton className="right-[0] min-w-[160px] " content={menuContent} />
                    </div>
                )}
            </div>
            <div className="flex w-full justify-between gap-6 items-center truncate">
                {!!dataElements.length &&
                    dataElements.map((el, index) => (
                        <div key={index} className="w-full">
                            {el}
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default InsightBanner;
